/* eslint-disable no-unused-vars */
import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
enum ActionType {
  VEHICLE_POSITION = 'VEHICLE_POSITION',
  IMPASSABLE_AREA_ADD = 'IMPASSABLE_AREA_ADD',
  IMPASSABLE_AREA_DELETE = 'IMPASSABLE_AREA_DELETE',
  IMPASSABLE_AREA_LIST = 'IMPASSABLE_AREA_LIST',
  USER_STATION_LINK = 'USER_STATION_LINK',
  CLEAR_IMPASSABLE_AREA_LIST = 'CLEAR_IMPASSABLE_AREA_LIST',
}

export const actionFetchVehiclePosition = createAction<any>(
  eventProvider.makeResponseType(ActionType.VEHICLE_POSITION),
);

// export const actionAddImpassableArea = createAction<any>(
//   eventProvider.makeResponseType(ActionType.IMPASSABLE_AREA_ADD)
// );

// export const actionDeleteImpassableArea = createAction<any>(
//   eventProvider.makeResponseType(ActionType.IMPASSABLE_AREA_DELETE)
// );

// export const actionFetchImpassableAreaList = createAction<any>(
//   eventProvider.makeResponseType(ActionType.IMPASSABLE_AREA_LIST)
// );

export const actionFetchStationPosition = createAction<any>(
  eventProvider.makeResponseType(ActionType.USER_STATION_LINK),
);

export const clearImpassableAreaList = createAction(
  ActionType.CLEAR_IMPASSABLE_AREA_LIST,
);

export default ActionType;
